/* React Bits BorderGlow pointer geometry, adapted to existing Shopify surfaces.
 * Copyright (c) 2026 David Haz. MIT + Commons Clause; see loc-react-bits-LICENSE.txt. */
(() => {
  if (window.LocBorderGlow) return;
  const records = new Map();
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const selector = '.loc-dark-home .loc-store__poster-frame, .loc-tcg-card-art, #essential-loyalty-landing-page .essential-card';
  const eligible = el => !el.closest('.loc-tcg-card') || el.closest('.loc-tcg-card').classList.contains('is-active');
  function bind(el) {
    if (records.has(el)) return;
    const controller = new AbortController();
    const layer = document.createElement('span');
    layer.className = 'loc-border-glow-layer'; layer.setAttribute('aria-hidden', 'true');
    el.classList.add('loc-border-glow'); el.append(layer);
    let frame = 0, point = null;
    const reset = () => { cancelAnimationFrame(frame); frame = 0; el.style.setProperty('--loc-edge-proximity', '0'); };
    const draw = () => {
      frame = 0;
      if (!point || !eligible(el)) { reset(); return; }
      const rect = el.getBoundingClientRect();
      const cx = rect.width / 2, cy = rect.height / 2;
      if (!cx || !cy) return;
      const dx = point.x - rect.left - cx, dy = point.y - rect.top - cy;
      // The original edge-proximity and cursor-angle calculation.
      const kx = dx === 0 ? Infinity : cx / Math.abs(dx);
      const ky = dy === 0 ? Infinity : cy / Math.abs(dy);
      const edge = Math.min(Math.max(1 / Math.min(kx, ky), 0), 1);
      let degrees = Math.atan2(dy, dx) * 180 / Math.PI + 90;
      if (degrees < 0) degrees += 360;
      el.style.setProperty('--loc-edge-proximity', (edge * 100).toFixed(3));
      el.style.setProperty('--loc-cursor-angle', degrees.toFixed(3) + 'deg');
    };
    el.addEventListener('pointermove', e => {
      if (e.pointerType === 'touch' || reduced.matches) return;
      point = { x: e.clientX, y: e.clientY };
      if (!frame) frame = requestAnimationFrame(draw);
    }, { passive: true, signal: controller.signal });
    el.addEventListener('pointerleave', reset, { signal: controller.signal });
    const focusHost = el.closest('a, button') || el;
    focusHost.addEventListener('focusin', () => {
      if (!eligible(el)) return;
      el.style.setProperty('--loc-edge-proximity', '85');
      el.style.setProperty('--loc-cursor-angle', '45deg');
    }, { signal: controller.signal });
    focusHost.addEventListener('focusout', reset, { signal: controller.signal });
    records.set(el, () => { controller.abort(); reset(); layer.remove(); el.classList.remove('loc-border-glow'); });
  }
  function scan() {
    document.querySelectorAll(selector).forEach(bind);
    records.forEach((clean, el) => { if (!el.isConnected) { clean(); records.delete(el); } });
  }
  let scanFrame = 0;
  const schedule = () => { if (!scanFrame) scanFrame = requestAnimationFrame(() => { scanFrame = 0; scan(); }); };
  const observer = new MutationObserver(changes => {
    // Ignore animation text spans and our own decorative layers.
    if (changes.some(c => [...c.addedNodes, ...c.removedNodes].some(n => n.nodeType === 1 && !n.matches('.loc-border-glow-layer, .loc-split-visual, .loc-rb-word, .loc-rb-char')))) schedule();
  });
  scan();
  const main = document.querySelector('#MainContent');
  if (main) observer.observe(main, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:unload', schedule);
  window.LocBorderGlow = { scan, count: () => records.size };
})();
